module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break"
  }, [_vm._v("Author’s Note")]), _vm._v(" "), _c('p', {
    staticClass: "Flush-left"
  }, [_vm._v("Until the mid-1600s, the town of Perth, Scotland, was St. John’s Town of Perth, after its namesake. Perth was the entire region now known as Perthshire.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Medieval Highlanders rarely used surnames, because most people in a given area belonged to one clan. In this book, for example, Gaelic "), _c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("Mòr")]), _vm._v(", as in Glen Mòr and Shaw Mòr, means “the Great.” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text"
  }, [_vm._v("Kilts were nonexistent until the sixteenth century. But dyes came from local plants, so woven wool garments in one area might have colors and/or patterns distinctive to that area. Clan tartans came along much later and became popular after Queen Victoria visited Scotland (1842) and acquired Balmoral (1852).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-994bddbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled-1-1.vue
// module id = 69
// module chunks = 0